import React from 'react';
import moment from 'moment';

export const Notifications = (props) => {
  const { notifications } = props;
  return (
    <>
      <div className=''>
        <h2 className=''>Notifications</h2>
        <hr />
        <ul className=''>
          {notifications && notifications.map(item => {
            return (
              <li key={item.id} className=''>
                <span className=''>{item.userName}</span>
                <span> {item.content}</span>
                <div className=''>
                  {moment(item.time.toDate()).fromNow()}
                </div>
              </li>
            )
          })
          }
        </ul>
      </div>
    </>
  )
}
